import React, { useContext } from "react";
import "./ProductItems.css";
import ProductContext from "../Context/productContext";

const ProductItems = (props) => {

  const context = useContext(ProductContext);
  const { deleteProduct } = context;
  const {  updateProduct,item } = props;

  return (
    <div className="product-container-card">
      <div className="product-container-body">
        <div className="product-img">
          <img src={item.image} alt="" />
        </div>
        <div className="product-title">
          <p>{item.title}     ({item.color})</p>
        </div>
        <div className="product-grp-btn">
          <button
            className="edit-btn"
            data-bs-toggle="modal"
            data-bs-target="#editModal"
            onClick={() => 
              updateProduct(item)
            }
          >
            Edit
          </button>
          <button
            className="delete-btn"
            onClick={() => {
              deleteProduct(item.id,item.image);
              props.setAlertMessage('Product Deleted');

              props.setShowAlert(true);
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProductItems;
